import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { Typography } from 'shared';
import FileUpload from 'shared_DEPRECATED/components/Form/FileUpload';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer/Spacer';

import { ChatAttachmentUploaded } from 'features/chat/components/ChatAttachment/Uploaded';
import { CHAT_FORM_FIELD_NAMES } from 'features/chat/config';
import { UnuploadedAttachment } from 'features/chat/config/types/Attachment';

import { ButtonIcon } from 'shared/components/Button';

export const ChatFilesPreview = () => {
  const methods = useFormContext();
  const files = useWatch({
    control: methods.control,
    name: CHAT_FORM_FIELD_NAMES.FILES,
  }) as UnuploadedAttachment[];

  return (
    <>
      {files.map((file, index) => {
        return (
          <React.Fragment key={file.name}>
            <ChatAttachmentUploaded file={file}>
              <ButtonIcon
                aria-label="remove file"
                onClick={() =>
                  methods.setValue(
                    CHAT_FORM_FIELD_NAMES.FILES,
                    files.filter((_, i) => i !== index)
                  )
                }
              >
                <Icon name={iconNames.cross} width="10px" height="10px" />
              </ButtonIcon>
            </ChatAttachmentUploaded>
            <Spacer size="zr zr md" />
          </React.Fragment>
        );
      })}
      <FileUpload
        onFileUpload={(uploadedFiles: File[]) => {
          if (!uploadedFiles) {
            return;
          }

          methods.setValue(CHAT_FORM_FIELD_NAMES.FILES, [
            ...files,
            ...uploadedFiles.map((file) => ({
              name: file.name,
              contentLength: file.size,
              contentType: file.type,
              url: URL.createObjectURL(file),
              file,
            })),
          ]);
        }}
      >
        <Icon
          name={iconNames.plus}
          stroke="var(--fgTertiary)"
          strokeWidth={1}
        />
        <Spacer size="zr xsm" />
        <Typography color="black" fontWeight="medium" type="small">
          Add more
        </Typography>
      </FileUpload>
    </>
  );
};
